import { render, staticRenderFns } from "./shuhai-carousel.vue?vue&type=template&id=53b7db2e&scoped=true"
import script from "./shuhai-carousel.vue?vue&type=script&lang=js"
export * from "./shuhai-carousel.vue?vue&type=script&lang=js"
import style0 from "./shuhai-carousel.vue?vue&type=style&index=0&id=53b7db2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7db2e",
  null
  
)

export default component.exports